import { Container, Typography, Box, Grid, TextField, Button, Link } from '@mui/material'
import { FormEvent, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { getConfiguration } from '../../clients/configuration'
import { AuthenticationApi } from '../../clients'
import { AppAlert } from '../../components/AppAlerts/AppAlerts'
import { useAppDispatch } from '../../redux/hooks'
import { addAlertWithTimeout } from '../../redux/features/alerts/alertsHelpers'
import { RecaptchaService } from '../../services/recaptchaService'

export const ForgotPassword = () => {

    const dispatch = useAppDispatch()
    const [email, setEmail] = useState<string>('')
    const [emailError, setEmailError] = useState<string>('')
    const [submitting, setSubmitting] = useState<boolean>(false)

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (handleEmailBlur()) {
            return
        }
        const recaptchaService = new RecaptchaService()
        const token = await recaptchaService.getToken()
            .catch(() => '')
        setSubmitting(true)
        const configuration = await getConfiguration()
        const authenticationAPI = new AuthenticationApi(configuration)
        await authenticationAPI.sendForgotPasswordEmail({
            sendForgotPasswordEmailRequest: {
                email: email,
                recaptchaToken: token,
            }
        }).then(() => {
            const appAlert = new AppAlert('success', 'Sent forgot password email')
            addAlertWithTimeout(dispatch, appAlert)
        }).catch(() => {
            const appAlert = new AppAlert('error', 'Something went wrong, try again later')
            addAlertWithTimeout(dispatch, appAlert)
        })
        setSubmitting(false)
    }

    const handleEmailFocus = () => {
        setEmailError('')
    }

    const handleEmailBlur = (): string => {
        const emailRegex = new RegExp(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g)
        if (!email.match(emailRegex)?.length) {
            const err = 'Invalid email address'
            setEmailError(err)
            return err
        }
        return ''
    }

    return (
        <Container component='div' maxWidth='sm'>
            <Typography component="h1" variant="h5" sx={{ mt: 8, textAlign: 'center' }}>
                Forgot Password
            </Typography>
            <Box component='form' onSubmit={handleSubmit} sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            required
                            fullWidth
                            value={email}
                            error={!!emailError}
                            helperText={emailError}
                            onFocus={handleEmailFocus}
                            onBlur={handleEmailBlur}
                            onChange={(e) => setEmail(e.target.value)}
                            label='Email'
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ mt: 1 }}>
                    <Grid size={{ xs: 12 }} display='flex' justifyContent='end'>
                        <RouterLink to='/auth/sign-in'><Link component='p'>Sign In</Link></RouterLink>
                    </Grid>
                </Grid>
                <Button disabled={submitting || !!emailError || !email} type='submit' fullWidth variant="contained" color="primary" sx={{ mt: 2, mb: 2 }}>Reset Password</Button>
                <Box sx={{ textAlign: 'center', my: 1, mb: 0 }}>
                    <Typography variant='caption'>
                        This site is protected by reCAPTCHA and the Google&nbsp;
                        <a href="https://policies.google.com/privacy">Privacy Policy</a> and&nbsp;
                        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                    </Typography>
                </Box>
            </Box>
        </Container>
    )
}